<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @unitData="v=>$emit('change', v)"
    :placeholder="placeholder"
    :clearable="clearable"
    idKey="UnitId"
    labelKey="UnitName"
    :get-data-func="getDataFunc"
    :params="params"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择计量单位",
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/unit").default,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list({...params, Status: 1 }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

